module.exports = __webpack_public_path__ + "static/media/girl_cutting_grass_no_talk.17af6dee.png";